import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth2Service } from '../../auth/auth2.service';
import { authTokenStorageKey } from '../../app.constants';

@Component({
  selector: 'app-welcome',
  template: '<h2>Nous chargeons vos données</h2>',
  standalone: true
})
export class WelcomeComponent implements OnInit {
  readonly #activatedRoute = inject(ActivatedRoute);
  readonly #auth2Service = inject(Auth2Service);
  readonly #router = inject(Router);

  ngOnInit() {
    // Grab token from url if exists
    const jwt = this.#activatedRoute.snapshot.queryParams['jwt'];
    if (jwt) {
      // set the token then perform the "user load"
      localStorage.setItem(authTokenStorageKey, jwt);
      this.#auth2Service.loadUser();
      void this.#router.navigate(['/logifleet']);
    }
  }
}
